<div class="output-container">
  <div class="output-container__header controls output pl-1">
    <div class="left output-left">
      <div class="def-output flex flex-row">
        <span
          class="font-newJuneBold text-xl mr-2"
          *ngIf="!editName"
          >{{
            currentScope
              ? outputTemplate.exportName
                ? outputTemplate.exportName
                : currentScope.name
              : outputTemplate.name
          }}</span
        >
        <mat-icon
          (click)="editName = true"
          *ngIf="!editName"
          class="material-symbols-rounded orange cursor-pointer text-lg"
          >mode_edit</mat-icon
        >
        <scope-ui-input
          *ngIf="editName"
          [initialValue]="
            currentScope
              ? outputTemplate.exportName
                ? outputTemplate.exportName
                : currentScope.name
              : outputTemplate.name
          "
          (onEnter)="submitName()"
          (onInputBlurChange)="submitName()"
          (onInputChange)="currentScope ? (outputTemplate.exportName = $event) : (outputTemplate.name = $event)" />
        <mat-icon
          (click)="submitName()"
          *ngIf="editName"
          class="material-symbols-rounded orange cursor-pointer !text-xl"
          >check</mat-icon
        >
        <span *ngIf="currentScope">
          <i
            class="material-icons material-symbols-rounded orange pointer mr-1 text-xl"
            matTooltip="By default file name corresponds to the Scope name ({{
              currentScope.name
            }}). You can change the name of current template. Leave blank form to return it by default"
            >help_outline</i
          >
        </span>
      </div>
      <div
        class="text-sm ml-1 block mb-3"
        *ngIf="!editName"
        matTooltip="Name of the Company template">
        {{ outputTemplate.name }}
      </div>
    </div>
    <div class="float-right">
      <div class="flex items-center relative">
        <div
          class="flex items-center"
          *ngIf="!currentScope">
          <mat-checkbox
            [(ngModel)]="outputTemplate.isDefault"
            [disabled]="outputTemplate.isDefault"
            (ngModelChange)="updateTemplate()" />
          <label class="text-sm">Default template</label>
        </div>
        <div
          class="flex items-center"
          *ngIf="outputTemplate?.htmlTemplate">
          <mat-checkbox
            [(ngModel)]="outputTemplate.pageBreakable"
            (ngModelChange)="updateTemplate()" />
          <label class="text-sm">Include page breaks by section</label>
        </div>
      </div>
    </div>
  </div>

  <div class="output-container__body">
    <div
      class="lateral-menu"
      cdkDropList
      cdkDropListOrientation="vertical"
      (cdkDropListDropped)="drop($event)"
      [cdkDropListData]="outputTemplate.outputFields">
      <div
        *ngFor="let field of outputTemplate.outputFields | orderBy: 'modifiedOrder' : 'asc' : false; trackBy: trackById"
        [hidden]="field.disabled"
        cdkDrag
        [cdkDragData]="field"
        [cdkDragDisabled]="isNotDraggable(field)">
        <div
          class="section"
          [ngClass]="{ 'orange-active': field.active, deleted: field.softDeleted }"
          (click)="setSectionActive(field, outputTemplate.outputFields)">
          <div
            class="left"
            style="width: inherit; height: inherit">
            <i
              class="material-symbols-rounded drag-indicator cursor-pointer"
              style="font-size: 16px"
              *ngIf="!isTemplateWhitelisted && !isNotDraggable(field)">
              drag_indicator
            </i>
            <span class="name cursor-pointer text-sm">
              {{ field.name }}
            </span>
          </div>
          <div class="right">
            <div
              class="icon-wrap"
              *ngIf="
                field.editable &&
                (field.fieldType === 'BLANK_HEADER' || field.fieldType === 'BLANK_FOOTER') &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted
              "
              (click)="setRepeatable(field)">
              <img
                class="material-symbols-rounded md-48"
                matTooltip="Repeat {{ field.fieldType === 'BLANK_HEADER' ? 'Header' : 'Footer' }} On Every Page (ON)"
                *ngIf="
                  (field.fieldType === 'BLANK_HEADER' && field.headerRepeatable) ||
                  (field.fieldType === 'BLANK_FOOTER' && field.footerRepeatable)
                "
                src="/assets/icons/repeatable.svg"
                alt="repeatable on" />
              <img
                class="material-symbols-rounded md-48 rotate-180"
                matTooltip="Repeat {{ field.fieldType === 'BLANK_HEADER' ? 'Header' : 'Footer' }} On Every Page (OFF)"
                *ngIf="
                  (field.fieldType === 'BLANK_HEADER' && !field.headerRepeatable) ||
                  (field.fieldType === 'BLANK_FOOTER' && !field.footerRepeatable)
                "
                src="/assets/icons/repeatable.svg"
                alt="repeatable off" />
            </div>
            <div
              matTooltip="Lock content block"
              class="hidden"
              (click)="lockOrUnlockField(field, false)"
              *ngIf="
                !currentScope &&
                field.editable &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted &&
                !field.softDeleted
              ">
              <mat-icon class="material-symbols-rounded">lock_open_right</mat-icon>
            </div>
            <div
              matTooltip="Unlock content block"
              (click)="lockOrUnlockField(field, true)"
              *ngIf="
                !field.editable &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted &&
                !field.softDeleted
              ">
              <mat-icon class="material-symbols-rounded">lock</mat-icon>
            </div>
            <div
              matTooltip="Delete content block"
              class="hidden"
              *ngIf="
                !currentScope &&
                field.editable &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted &&
                !field.softDeleted
              "
              (click)="temporarilyDeleteField(field)">
              <mat-icon class="material-symbols-rounded">delete</mat-icon>
            </div>
            <div
              matTooltip="Hide content block"
              class="hidden"
              *ngIf="
                currentScope &&
                field.editable &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted &&
                !field.softDeleted
              "
              (click)="temporarilyDeleteField(field)">
              <mat-icon class="material-symbols-rounded">visibility</mat-icon>
            </div>
            <div
              matTooltip="Show content block"
              class="hidden"
              *ngIf="
                currentScope &&
                field.editable &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted &&
                field.softDeleted
              "
              (click)="restoreField(field)">
              <mat-icon class="material-symbols-rounded">visibility_off</mat-icon>
            </div>
            <div
              matTooltip="Restore content block"
              class="hidden"
              *ngIf="
                !currentScope &&
                field.editable &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted &&
                field.softDeleted
              "
              (click)="restoreField(field)">
              <mat-icon class="material-symbols-rounded">undo</mat-icon>
            </div>
            <div
              matTooltip="Delete content block permanently"
              class="hidden"
              *ngIf="
                !currentScope &&
                field.editable &&
                outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                !isTemplateWhitelisted &&
                field.softDeleted
              "
              (click)="deleteField(field)">
              <mat-icon class="material-symbols-rounded">close</mat-icon>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex d-flex-direction-colum d-flex-align-center">
        <div
          class="section-controls second-party-title-click d-flex d-flex-align-center d-flex-justify-center fade-in"
          (click)="showAddContentBlockModal()"
          *ngIf="outputTemplate.documentTemplate !== 'PHM_TEMPLATE' && !isTemplateWhitelisted">
          <span
            ><i class="material-icons material-symbols-rounded">add</i>
            <span class="primary-blue-violet margin-l5">Add content block</span></span
          >
        </div>
        <div
          class="section-controls second-party-title-click d-flex d-flex-align-center d-flex-justify-center fade-in"
          (click)="addSpecialBlock('BLANK_HEADER', 'Header')"
          *ngIf="
            !hasHeader &&
            outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
            !isTemplateWhitelisted &&
            !currentScope &&
            isHtmlTemplate
          ">
          <span
            ><i class="material-icons material-symbols-rounded">add</i>
            <span class="primary-blue-violet margin-l5">Add Header</span></span
          >
        </div>
        <div
          class="section-controls second-party-title-click d-flex d-flex-align-center d-flex-justify-center fade-in"
          (click)="addSpecialBlock('BLANK_FOOTER', 'Footer')"
          *ngIf="
            !hasFooter &&
            outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
            !isTemplateWhitelisted &&
            !currentScope &&
            isHtmlTemplate
          ">
          <span
            ><i class="material-icons material-symbols-rounded">add</i>
            <span class="primary-blue-violet margin-l5">Add Footer</span></span
          >
        </div>
        <div
          class="section-controls second-party-title-click d-flex d-flex-align-center d-flex-justify-center fade-in"
          (click)="addSpecialBlock('COVER_PAGE', 'Cover Page')"
          *ngIf="
            !hasCover &&
            outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
            !isTemplateWhitelisted &&
            !currentScope &&
            isHtmlTemplate
          ">
          <span
            ><i class="material-icons material-symbols-rounded">add</i>
            <span class="primary-blue-violet margin-l5">Add Cover Page</span></span
          >
        </div>
        <div class="separator"></div>
        <div
          class="section-controls second-party-title-click d-flex d-flex-align-center d-flex-justify-center"
          (click)="showAddBordersModal()">
          <span
            ><i
              class="material-icons material-symbols-rounded"
              style="font-size: 20px"
              >border_all</i
            ><span class="primary-blue-violet margin-l5">Edit margins</span></span
          >
        </div>
      </div>
    </div>

    <div class="d-flex d-flex-direction-colum">
      <div
        class="text-editor-section"
        [ngClass]="{ 'active-block': !activeSection?.softDeleted, 'deleted-block': activeSection?.softDeleted }">
        <div
          class="editor-controls d-flex d-flex-align-center d-flex-justify-between"
          *ngIf="!activeSection?.softDeleted">
          <div>
            <span
              class="name pointer bold"
              *ngIf="activeSection && !activeSection.editName"
              >{{ activeSection?.name }}
              <i
                (click)="
                  $event.stopPropagation();
                  $event.preventDefault();
                  activeSection.editName = true;
                  $event.stopPropagation()
                "
                *ngIf="
                  activeSection?.editable &&
                  outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                  !isTemplateWhitelisted
                "
                class="material-symbols-rounded fill material-symbols-rounded orange"
                style="font-size: 14px"
                >mode_edit</i
              >
            </span>
            <div
              *ngIf="activeSection && activeSection.editName"
              class="flex"
              style="width: 200px; margin: 0; height: inherit; font-family: NewJune, Verdana, Geneva, sans-serif">
              <scope-ui-input
                [initialValue]="activeSection?.name"
                (onInputBlurChange)="activeSection.name = $event; activeSection.editName = false; updateTemplate()" />
              <div class="name pointer bold orange">
                <mat-icon
                  (click)="activeSection.editName = false; updateTemplate()"
                  *ngIf="
                    activeSection?.editable &&
                    outputTemplate.documentTemplate !== 'PHM_TEMPLATE' &&
                    !isTemplateWhitelisted
                  "
                  class="material-symbols-rounded orange cursor-pointer"
                  >check</mat-icon
                >
              </div>
            </div>
          </div>

          <div
            class="d-flex"
            *ngIf="
              (currentScope && (activeSection?.id || activeSection?.name)) ||
              ((activeSection?.id || activeSection?.name) &&
                !activeSection?.softDeleted &&
                !(activeSection?.children && activeSection?.children.length > 0) &&
                outputTemplate.htmlTemplate)
            ">
            <ng-container *ngFor="let tab of EDITOR_TABS">
              <div
                class="editor-tab font-14"
                *ngIf="tab.visible()"
                [ngClass]="{ active: tab.active, inactive: !tab.active }"
                (click)="tab.onClick(tab)">
                <i
                  class="material-icons material-symbols-rounded"
                  style="color: #333844; font-size: 16px; margin-bottom: 3px; margin-right: 5px"
                  >{{ tab.icon }}</i
                >
                <span
                  class="font-newJuneBold text-xs"
                  [ngClass]="{ active: tab.active, inactive: !tab.active }"
                  >{{ tab.name }}</span
                >
              </div>
            </ng-container>
          </div>
        </div>
        <div
          *ngIf="!(activeSection?.id || activeSection?.name)"
          class="bold"
          style="font-size: 28px; color: #a6afc3">
          Select a content block to edit
        </div>

        <div
          *ngIf="(activeSection?.id || activeSection?.name) && previewLoading"
          class="d-flex d-flex-justify-center d-flex-align-center"
          style="height: 80%">
          <div class="preview-text-container">
            <span class="preview-text"
              >Please bear with us for <br />
              a few seconds as we fetch your data.</span
            >
            <span
              class="hidden-preview-text"
              style="line-height: 2.3; display: none"
              >Almost here...</span
            >
            <div style="width: 100%">
              <div class="loader-line">
                <div class="line"></div>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="activeSection?.softDeleted && !currentScope"
          class="d-flex d-flex-direction-colum d-flex-align-center d-flex-justify-center"
          style="height: inherit; color: #484e5d">
          <div style="font-size: 20px; width: 675px; text-align: center">
            This block has been temporarily deleted. It is currently not visible in the preview or the output and cannot
            be edited. If you wish to make changes, please restore it. If you no longer need this block, it can be
            permanently deleted.
          </div>
          <div
            class="bold d-flex"
            style="font-size: 18px">
            <div
              class="deleted-block-controls d-flex pointer"
              (click)="restoreField(activeSection)">
              <svg
                class="mr-1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none">
                <mask
                  id="mask0_4237_2567"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="17">
                  <rect
                    y="0.5"
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_4237_2567)">
                  <path
                    d="M5.33328 13.1666C5.1444 13.1666 4.98606 13.1027 4.85828 12.975C4.73051 12.8472 4.66662 12.6888 4.66662 12.5C4.66662 12.3111 4.73051 12.1527 4.85828 12.025C4.98606 11.8972 5.1444 11.8333 5.33328 11.8333H9.39995C10.1 11.8333 10.7083 11.6111 11.225 11.1666C11.7416 10.7222 12 10.1666 12 9.49995C12 8.83328 11.7416 8.27773 11.225 7.83328C10.7083 7.38884 10.1 7.16662 9.39995 7.16662H5.19995L6.46662 8.43328C6.58884 8.55551 6.64995 8.71106 6.64995 8.89995C6.64995 9.08884 6.58884 9.2444 6.46662 9.36662C6.3444 9.48884 6.18884 9.54995 5.99995 9.54995C5.81106 9.54995 5.65551 9.48884 5.53328 9.36662L3.13328 6.96662C3.06662 6.89995 3.0194 6.82773 2.99162 6.74995C2.96384 6.67217 2.94995 6.58884 2.94995 6.49995C2.94995 6.41106 2.96384 6.32773 2.99162 6.24995C3.0194 6.17217 3.06662 6.09995 3.13328 6.03328L5.53328 3.63328C5.65551 3.51106 5.81106 3.44995 5.99995 3.44995C6.18884 3.44995 6.3444 3.51106 6.46662 3.63328C6.58884 3.75551 6.64995 3.91106 6.64995 4.09995C6.64995 4.28884 6.58884 4.4444 6.46662 4.56662L5.19995 5.83328H9.39995C10.4777 5.83328 11.4027 6.18328 12.175 6.88328C12.9472 7.58328 13.3333 8.45551 13.3333 9.49995C13.3333 10.5444 12.9472 11.4166 12.175 12.1166C11.4027 12.8166 10.4777 13.1666 9.39995 13.1666H5.33328Z"
                    fill="#FF6B00" />
                </g>
              </svg>
              Restore
            </div>
            <div
              class="deleted-block-controls d-flex pointer"
              (click)="deleteField(activeSection)">
              <svg
                class="mr-1"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none">
                <mask
                  id="mask0_4237_3342"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="17">
                  <rect
                    y="0.5"
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_4237_3342)">
                  <path
                    d="M4.26671 13.1666L3.33337 12.2333L7.06671 8.49992L3.33337 4.76659L4.26671 3.83325L8.00004 7.56659L11.7334 3.83325L12.6667 4.76659L8.93337 8.49992L12.6667 12.2333L11.7334 13.1666L8.00004 9.43325L4.26671 13.1666Z"
                    fill="#FF6B00" />
                </g>
              </svg>
              Delete permanently
            </div>
          </div>
        </div>
        <div
          *ngIf="activeSection?.softDeleted && currentScope"
          class="d-flex d-flex-direction-colum d-flex-align-center d-flex-justify-center"
          style="height: inherit; color: #484e5d">
          <div class="hidden-block-container text-2xl text-center">
            This block is currently hidden and disabled. It will not be visible <br />
            in the preview or the output. If you would like to edit it, please <br />
            enable.
          </div>
          <div class="bold d-flex">
            <div
              class="deleted-block-controls flex pointer align-middle"
              (click)="restoreField(activeSection)">
              <svg
                class="mr-1"
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none">
                <mask
                  id="mask0_4523_5257"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="17"
                  height="16">
                  <rect
                    x="0.5"
                    width="16"
                    height="16"
                    fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_4523_5257)">
                  <path
                    d="M8.38366 10.6666C9.21699 10.6666 9.92533 10.375 10.5087 9.79163C11.092 9.20829 11.3837 8.49996 11.3837 7.66663C11.3837 6.83329 11.092 6.12496 10.5087 5.54163C9.92533 4.95829 9.21699 4.66663 8.38366 4.66663C7.55033 4.66663 6.84199 4.95829 6.25866 5.54163C5.67533 6.12496 5.38366 6.83329 5.38366 7.66663C5.38366 8.49996 5.67533 9.20829 6.25866 9.79163C6.84199 10.375 7.55033 10.6666 8.38366 10.6666ZM8.38366 9.46663C7.88366 9.46663 7.45866 9.29163 7.10866 8.94163C6.75866 8.59163 6.58366 8.16663 6.58366 7.66663C6.58366 7.16663 6.75866 6.74163 7.10866 6.39163C7.45866 6.04163 7.88366 5.86663 8.38366 5.86663C8.88366 5.86663 9.30866 6.04163 9.65866 6.39163C10.0087 6.74163 10.1837 7.16663 10.1837 7.66663C10.1837 8.16663 10.0087 8.59163 9.65866 8.94163C9.30866 9.29163 8.88366 9.46663 8.38366 9.46663ZM8.38366 12.6666C6.83921 12.6666 5.4281 12.2583 4.15033 11.4416C2.87255 10.625 1.90588 9.52218 1.25033 8.13329C1.21699 8.07774 1.19477 8.00829 1.18366 7.92496C1.17255 7.84163 1.16699 7.75552 1.16699 7.66663C1.16699 7.57774 1.17255 7.49163 1.18366 7.40829C1.19477 7.32496 1.21699 7.25552 1.25033 7.19996C1.90588 5.81107 2.87255 4.70829 4.15033 3.89163C5.4281 3.07496 6.83921 2.66663 8.38366 2.66663C9.9281 2.66663 11.3392 3.07496 12.617 3.89163C13.8948 4.70829 14.8614 5.81107 15.517 7.19996C15.5503 7.25552 15.5725 7.32496 15.5837 7.40829C15.5948 7.49163 15.6003 7.57774 15.6003 7.66663C15.6003 7.75552 15.5948 7.84163 15.5837 7.92496C15.5725 8.00829 15.5503 8.07774 15.517 8.13329C14.8614 9.52218 13.8948 10.625 12.617 11.4416C11.3392 12.2583 9.9281 12.6666 8.38366 12.6666ZM8.38366 11.3333C9.63921 11.3333 10.792 11.0027 11.842 10.3416C12.892 9.68051 13.6948 8.78885 14.2503 7.66663C13.6948 6.5444 12.892 5.65274 11.842 4.99163C10.792 4.33051 9.63921 3.99996 8.38366 3.99996C7.1281 3.99996 5.97533 4.33051 4.92533 4.99163C3.87533 5.65274 3.07255 6.5444 2.51699 7.66663C3.07255 8.78885 3.87533 9.68051 4.92533 10.3416C5.97533 11.0027 7.1281 11.3333 8.38366 11.3333Z"
                    fill="#FF6B00" />
                </g>
              </svg>
              Show content block
            </div>
          </div>
        </div>
        <div
          id="active-section"
          [hidden]="previewLoading || !activeSection || activeSection.softDeleted">
          <div
            class="text-row-open output-row-content"
            [ngClass]="{ 'widgets-active': showWidgetsMenu, 'widgets-inactive': !showWidgetsMenu }">
            <ckeditor
              #editor
              editorUrl="/assets/ckeditor/ckeditor.js"
              class="{{ editorClass }}"
              [config]="ckeConfig"
              (namespaceLoaded)="namespaceLoaded()"
              (dataReady)="dataReady()"
              (ready)="onReady()"
              (change)="onChange()"
              [hidden]="blockHidden(activeSection, outputTemplate)">
            </ckeditor>

            <div
              *ngIf="
                activeSection &&
                (!activeSection.children || activeSection.children.length == 0) &&
                activeSection.fieldType?.indexOf('FOOTER') > -1 &&
                !outputTemplate.htmlTemplate
              ">
              <div class="footer-input-wrap">
                <p class="select-label">Footer content</p>
                <div>
                  <scope-ui-input
                    [ngModel]="activeSection?.content"
                    [initialValue]="activeSection?.content"
                    (onInputBlurChange)="
                      activeSection.content = $event; activeSection.editName = false; updateTemplate()
                    " />
                </div>
              </div>
            </div>
            <div
              *ngIf="activeSection?.children && activeSection?.children.length > 0"
              class="main-wrap">
              <div *ngFor="let child of activeSection?.children | orderBy: 'name'; trackBy: trackById">
                <div class="menu-title orange between">
                  <span
                    class="left li-name"
                    (click)="child.showAlignment = !child.showAlignment">
                    <span
                      class="carret"
                      *ngIf="!child.showAlignment"
                      ><i class="material-icons material-symbols-rounded">keyboard_arrow_down</i></span
                    >
                    <span
                      class="carret"
                      *ngIf="child.showAlignment"
                      ><i class="material-icons material-symbols-rounded">keyboard_arrow_up</i></span
                    >
                    <span>{{ child.name }}</span>
                  </span>
                </div>
                <ul
                  class="members-line-menu first-menu"
                  *ngIf="child.showAlignment">
                  <li *ngFor="let pos of position | orderBy: 'order'">
                    <span class="left">
                      <span class="name">
                        {{ pos.name }}
                        <span class="left-member-dropdown"> </span>
                      </span>
                    </span>
                    <span class="right">
                      <span class="left swicher">
                        <span
                          class="swich"
                          (click)="changeAlign(child, pos)"
                          [ngClass]="{ active: child.content == pos.key }"
                          >on</span
                        >
                        <span
                          class="swich"
                          [ngClass]="{ active: child.content != pos.key }"
                          >off</span
                        >
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="editor-footer d-flex d-flex-align-center d-flex-justify-between"
        [ngClass]="{ 'widgets-active': showWidgetsMenu, 'widgets-inactive': !showWidgetsMenu }">
        <span
          >Language: <span class="bold">{{ showLanguage(outputTemplate.language) }}</span></span
        >
        <span *ngIf="outputTemplate.updatedBy?.firstName && outputTemplate.updatedTs"
          >This document has been updated by {{ outputTemplate.updatedBy.getFullname() }} on
          {{ getFormattedDate() }}</span
        >
        <div class="d-flex d-flex-align-center">
          <span class="mr-1">Auto-Save enabled</span>
          <i
            style="width: 18px; font-size: 18px; margin-bottom: 5px"
            class="material-symbols-rounded orange"
            [ngClass]="{ 'icon-spinner': updateInProgress }"
            >{{ updateInProgress ? 'sync' : 'check' }}</i
          >
        </div>
      </div>
    </div>

    <div
      class="d-flex d-flex-direction-colum d-flex-justify-between"
      style="border-left: 1px solid #c0c9dd; width: 50px; padding-bottom: 10px; justify-content: space-between">
      <div>
        <div
          class="left-bar-icon"
          matTooltipShowDelay="500"
          matTooltip="Upload base template"
          (click)="uploadDocxBaseTemplateModal()"
          *ngIf="!isTemplateWhitelisted && !currentScope">
          <i class="material-icons material-symbols-rounded">upload_file</i>
        </div>

        <div
          class="left-bar-icon shadow-md"
          matTooltipShowDelay="500"
          matTooltip="{{ currentScope ? 'Preview document' : 'Preview master template' }}"
          (click)="previewExport()">
          <i class="material-icons material-symbols-rounded">preview</i>
        </div>

        <div
          class="left-bar-icon shadow-md"
          matTooltipShowDelay="500"
          matTooltip="Download document"
          (click)="downloadExport()"
          *ngIf="currentScope">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24">
            <path
              d="M480-313 287-506l43-43 120 120v-371h60v371l120-120 43 43-193 193ZM220-160q-24 0-42-18t-18-42v-143h60v143h520v-143h60v143q0 24-18 42t-42 18H220Z" />
          </svg>
        </div>

        <div
          class="left-bar-icon shadow-md"
          matTooltipShowDelay="500"
          matTooltip="Duplicate template"
          (click)="showDuplicateTemplateModal()"
          *ngIf="!currentScope">
          <i class="material-icons material-symbols-rounded">content_copy</i>
        </div>

        <div
          class="left-bar-icon shadow-md"
          matTooltipShowDelay="500"
          matTooltip="Show widgets and variables"
          (click)="showWidgetsMenu = !showWidgetsMenu; onSearch('')">
          <i class="material-icons material-symbols-rounded">widgets</i>
          <div [ngClass]="{ active: showWidgetsMenu }"></div>
        </div>
      </div>

      <div>
        <span
          class="left-bar-icon"
          matTooltipShowDelay="500"
          matTooltip="Download master template"
          (click)="downloadExport()"
          *ngIf="!currentScope">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24">
            <path
              d="M480-313 287-506l43-43 120 120v-371h60v371l120-120 43 43-193 193ZM220-160q-24 0-42-18t-18-42v-143h60v143h520v-143h60v143q0 24-18 42t-42 18H220Z" />
          </svg>
        </span>
        <span
          class="left-bar-icon shadow-md"
          matTooltipShowDelay="500"
          matTooltip="Change master template"
          (click)="showChangeScopeTemplate()"
          *ngIf="currentScope">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <path
              d="M7 9H17V7H7V9ZM7 13H11.75C12.0833 12.6 12.4458 12.2292 12.8375 11.8875C13.2292 11.5458 13.6583 11.25 14.125 11H7V13ZM7 17H10.05C10.0833 16.65 10.1458 16.3083 10.2375 15.975C10.3292 15.6417 10.4417 15.3167 10.575 15H7V17ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V10.575C20.6833 10.4417 20.3583 10.3292 20.025 10.2375C19.6917 10.1458 19.35 10.0833 19 10.05V5H5V19H10.05C10.0833 19.35 10.1458 19.6917 10.2375 20.025C10.3292 20.3583 10.4417 20.6833 10.575 21H5ZM18 23C16.7833 23 15.7208 22.6208 14.8125 21.8625C13.9042 21.1042 13.3333 20.15 13.1 19H14.65C14.8667 19.7333 15.2792 20.3333 15.8875 20.8C16.4958 21.2667 17.2 21.5 18 21.5C18.9667 21.5 19.7917 21.1583 20.475 20.475C21.1583 19.7917 21.5 18.9667 21.5 18C21.5 17.0333 21.1583 16.2083 20.475 15.525C19.7917 14.8417 18.9667 14.5 18 14.5C17.5167 14.5 17.0667 14.5875 16.65 14.7625C16.2333 14.9375 15.8667 15.1833 15.55 15.5H17V17H13V13H14.5V14.425C14.95 13.9917 15.475 13.6458 16.075 13.3875C16.675 13.1292 17.3167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23Z" />
          </svg>
        </span>
        <span
          class="left-bar-icon shadow-md"
          matTooltipShowDelay="500"
          matTooltip="Apply master template changes"
          (click)="applyMasterTemplateChanges()"
          *ngIf="currentScope">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <path
              d="M12.05 19L14.9 16.175L12.05 13.35L11 14.4L12.075 15.475C11.6083 15.4917 11.1542 15.4167 10.7125 15.25C10.2708 15.0833 9.875 14.825 9.525 14.475C9.19167 14.1417 8.9375 13.7583 8.7625 13.325C8.5875 12.8917 8.5 12.4583 8.5 12.025C8.5 11.7417 8.5375 11.4583 8.6125 11.175C8.6875 10.8917 8.79167 10.6167 8.925 10.35L7.825 9.25C7.54167 9.66667 7.33333 10.1083 7.2 10.575C7.06667 11.0417 7 11.5167 7 12C7 12.6333 7.125 13.2583 7.375 13.875C7.625 14.4917 7.99167 15.0417 8.475 15.525C8.95833 16.0083 9.5 16.3708 10.1 16.6125C10.7 16.8542 11.3167 16.9833 11.95 17L11 17.95L12.05 19ZM16.175 14.75C16.4583 14.3333 16.6667 13.8917 16.8 13.425C16.9333 12.9583 17 12.4833 17 12C17 11.3667 16.8792 10.7375 16.6375 10.1125C16.3958 9.4875 16.0333 8.93333 15.55 8.45C15.0667 7.96667 14.5208 7.60833 13.9125 7.375C13.3042 7.14167 12.6833 7.025 12.05 7.025L13 6.05L11.95 5L9.1 7.825L11.95 10.65L13 9.6L11.9 8.5C12.35 8.5 12.8083 8.5875 13.275 8.7625C13.7417 8.9375 14.1417 9.19167 14.475 9.525C14.8083 9.85833 15.0625 10.2417 15.2375 10.675C15.4125 11.1083 15.5 11.5417 15.5 11.975C15.5 12.2583 15.4625 12.5417 15.3875 12.825C15.3125 13.1083 15.2083 13.3833 15.075 13.65L16.175 14.75ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" />
          </svg>
        </span>
        <div style="min-height: 20px; border-top: 1px solid #c0c9dd"></div>
      </div>
    </div>
    <div
      *ngIf="showWidgetsMenu"
      class="pl-1.5">
      <div class="flex justify-between px-4 pt-1 items-center">
        <span>Variables</span>
        <span>
          <i
            class="material-icons material-symbols-rounded orange pointer mr-1 text-lg"
            matTooltip="You can drag-n-drop variables and content widgets using your cursor.
                    Click and hold the variable/widget when it's highlighted and move it on your content block. Check (?) near widget to verify where it can be placed."
            >help_outline</i
          >
          <i
            class="material-icons material-symbols-rounded orange pointer mr-1 text-lg"
            matTooltip="Close"
            (click)="showWidgetsMenu = !showWidgetsMenu; onSearch('')"
            >close</i
          >
        </span>
      </div>
      <div class="variable-search mb-2 min-h-fit">
        <scope-ui-input
          [icon]="'search'"
          (onInputChange)="onSearch($event)"
          [inputClass]="'mx-5 icon-field'" />
      </div>
      <ul id="widgetList">
        <li (click)="scopeVariablesVisible = !scopeVariablesVisible">
          <div class="flex items-center">
            <i
              class="material-icons material-symbols-rounded text-lg arrow-down-scope"
              [ngClass]="{ rotate: scopeVariablesVisible }"
              >keyboard_arrow_down</i
            >
            <div class="pl-2.5">Scope Variables</div>
          </div>
          <ul
            *ngIf="scopeVariablesVisible"
            (click)="$event.stopPropagation()">
            <li
              class="pl-5 pb-1"
              *ngFor="let scopeVariable of scopeVariables | orderBy: 'name'; trackBy: trackById"
              [hidden]="!variableVisible(scopeVariable)">
              <span
                draggable="true"
                class="{{ scopeVariable.key }} {{ ['SCOPE'] }}">
                {{ scopeVariable.name }}
              </span>
            </li>
          </ul>
        </li>

        <li
          *ngFor="let widget of widgets | sortBySupports; trackBy: trackById"
          (click)="widget.visible = !widget.visible"
          [hidden]="!widgetVisible(widget)">
          <div
            class="flex items-center justify-between"
            [ngStyle]="{ 'margin-left': widget.priority + '0px' }">
            <div class="flex items-center">
              <i
                class="material-icons material-symbols-rounded text-lg arrow-down-scope"
                [ngClass]="{ rotate: widget.visible }"
                >keyboard_arrow_down</i
              >
              <span
                draggable="true"
                class="{{ widget.key }} {{ widget.supports }}">
                {{ widget.name }}
              </span>
            </div>
            <i
              class="material-icons material-symbols-rounded pointer mr-1 text-sm description-tooltip-icon"
              [matTooltip]="formatDescription(widget)"
              >help_outline</i
            >
          </div>
          <ul
            *ngIf="widget.visible"
            (click)="$event.stopPropagation()">
            <li
              class="pl-5 py-1"
              *ngFor="let variable of widget.variables | orderBy: 'name'; trackBy: trackById"
              [hidden]="!variableVisible(variable)">
              <span
                draggable="true"
                class="{{ variable.key }} {{ variable.supportsEntity }}">
                {{ removeWidgetName(variable.name, widget.name) }}
              </span>
            </li>
          </ul>
        </li>

        <li
          (click)="scopeTablesVisible = !scopeTablesVisible"
          [hidden]="!tableVisible()">
          <div class="flex items-center">
            <i
              class="material-icons material-symbols-rounded text-lg arrow-down-scope"
              [ngClass]="{ rotate: scopeTablesVisible }"
              >keyboard_arrow_down</i
            >
            <div class="pl-2.5">Scope Tables/Widgets</div>
          </div>
          <ul
            *ngIf="scopeTablesVisible"
            (click)="$event.stopPropagation()">
            <li
              class="pl-2 pb-1"
              *ngFor="let variable of scopeTables | orderBy: 'name'; trackBy: trackById"
              [hidden]="!variableVisible(variable)">
              <span
                draggable="true"
                class="{{ variable.key }} {{ variable.supports }}">
                {{ variable.name }}
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
